export default __webpack_public_path__ + "static/media/sleep.c6741a93.svg";